import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');

export const savePreviewPublish = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/login-screen/save-publish`,
        method: 'POST',
        headers: {
            'Content-Type': 'applications/json'
        },
        body: data
    };
    try {
        const response = await createRequest(options);
        return response;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const getScreenToEdit = async (body) => {
    const options = {
        url: `${Variable.backendUrl}/login-screen/getDataByName`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        body
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        return err;
    }
};
